declare namespace $ {

	type $yuf_number_string__blur_event_yuf_number_1 = $mol_type_enforce<
		ReturnType< $yuf_number['blur_event'] >
		,
		ReturnType< $yuf_number_string['blur_event'] >
	>
	type $yuf_number_string__type_yuf_number_2 = $mol_type_enforce<
		ReturnType< $yuf_number['type'] >
		,
		ReturnType< $yuf_number_string['type'] >
	>
	type $yuf_number_string__value_yuf_number_3 = $mol_type_enforce<
		ReturnType< $yuf_number['value_string'] >
		,
		ReturnType< $yuf_number_string['value'] >
	>
	type $yuf_number_string__hint_yuf_number_4 = $mol_type_enforce<
		ReturnType< $yuf_number['hint'] >
		,
		ReturnType< $yuf_number_string['hint'] >
	>
	type $yuf_number_string__enabled_yuf_number_5 = $mol_type_enforce<
		ReturnType< $yuf_number['string_enabled'] >
		,
		ReturnType< $yuf_number_string['enabled'] >
	>
	type $yuf_number_string__submit_yuf_number_6 = $mol_type_enforce<
		ReturnType< $yuf_number['submit'] >
		,
		ReturnType< $yuf_number_string['submit'] >
	>
	export class $yuf_number extends $mol_number {
		blur_event( next?: any ): any
		String( ): $yuf_number_string
	}
	
	export class $yuf_number_string extends $mol_string {
		blur_event( next?: any ): any
		event( ): ({ 
			blur( next?: ReturnType< $yuf_number_string['blur_event'] > ): ReturnType< $yuf_number_string['blur_event'] >,
		})  & ReturnType< $mol_string['event'] >
	}
	
}

//# sourceMappingURL=number.view.tree.d.ts.map